import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appMaxLengthNumber]',
  standalone: true,
})
export class MaxLengthNumberDirective {
  @Input() appMaxLengthNumber!: number; // Définit la longueur maximale

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement as HTMLInputElement;

    // Vérifie si la longueur de la valeur dépasse la limite
    if (input.value.length > this.appMaxLengthNumber) {
      input.value = input.value.slice(0, this.appMaxLengthNumber); // Tronque la valeur
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const pastedText = event.clipboardData?.getData('text') || '';

    // Si le texte collé dépasse la limite, empêche l'ajout complet
    if (pastedText.length + input.value.length > this.appMaxLengthNumber) {
      event.preventDefault();
      input.value = (input.value + pastedText).slice(
        0,
        this.appMaxLengthNumber,
      );
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;

    // Empêche l'entrée si la longueur maximale est atteinte
    if (input.value.length >= this.appMaxLengthNumber) {
      event.preventDefault();
    }
  }
}
